import { Select } from 'antd'
import { Form } from 'antd'
import { FC, useEffect } from 'react'
import { useLazyGetStampsQuery } from '../../../../../../../../../../store/api/stamps-api'
import _ from 'lodash'
import { EndpointQueryParameters } from '../../../../../../../../../../types/strapi/strapi'
import { requiredRules } from '../../../../../../../../../../constants/forms/validation/rules'
import useForm from '../../../hooks/form/use-form'

interface StampProps {}

const Stamp: FC<StampProps> = () => {
    const name = 'stamp'
    const form = useForm()
    const [get, state] = useLazyGetStampsQuery()

    const onSearch = _.debounce(async (query: string) => {
        if (query.length < 1) return
        const params: EndpointQueryParameters = { filters: { number: { $contains: query } } }
        await get(params)
    }, 500)

    useEffect(() => {
        if (form.getFieldValue('stamp')) {
            get({ filters: { documentId: { $eq: form.getFieldValue('stamp') } } })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Form.Item name={name} label={'Штамп'} rules={requiredRules}>
            <Select
                options={state.data?.data.map(item => ({
                    value: item.documentId,
                    label: `№ ${item.number} (${item.length} x ${item.width})`,
                }))}
                filterOption={() => true}
                onSearch={onSearch}
                showSearch
            />
        </Form.Item>
    )
}

export default Stamp
